import Select from "react-select";
import React, {useState} from "react";

export default function EducationLevel(){
    const [faculties , setFaculties]=useState([{ value :'Médecine' , label : 'Médecine'} , { value : 'Pharmacie' , label : 'Pharamacie'} ,  { label : 'Médecine Dentaire' , value : 'Médecine Dentaire'}]);
    const [selectedFaculty , setSelectedFaculty]=useState(null);
    const [levels , setLevels]=useState([{ value :'Etudiant en Medecine' , label : 'Etudiant en Medecine'} , { value : 'Resident' , label : 'Resident'} ,  { label : 'Etudiant en post-evaluation' , value : 'Etudinat en post-evaluation'} ]);
    const [selectedLevel , setSelectedLevel]=useState(null);
    const [specialities , setSpecialities]=useState([{ value :'Specialité 1' , label : 'Specialité 1'} , { value : 'Specialité 2' , label : 'Specialité 2'} ,  { label : 'Specialité 3' , value : 'Specialité 3'} ]);
    const [selectedSpeciality , setSelectedSpeciality]=useState(null);
    const [universities , setUniversities]=useState([{ value :'University 1' , label : 'University 1'} , { value : 'University 2' , label : 'University 2'} ,  { label : 'University 3' , value : 'University 3'}]);
    const [selectedUniversity , setSelectedUniversity]=useState(null);
    const [years , setedYear]=useState([{ value :1 , label : 'Premiére année'} , { value :2 , label : 'Deuxiéme année'} ,  { label : 'Troisiéme année' , value : 3}]);
    const [selectedYear , setSelectedYear]=useState(null);
    return (
        <div>
            <div className="row mb-4">
                <div className="col-12 mb-2"> Spécifiez votre université :</div>
                <div className="col-12">
                    <select value={selectedUniversity} onChange={(e)=>setSelectedUniversity(e.target.value)} className="form-control form-control-lg">
                        <option disabled selected value> -- Spécifiez votre Université -- </option>
                        {universities.map(country=><option value={country.value} key={country.value}>{country.label}</option>)}
                    </select>
                </div>
            </div>
            <div className="row mb-4">
                <div className="col-12 mb-2"> Spécifiez votre domaine :</div>
                <div className="col-12">
                    <select value={selectedFaculty} onChange={(e)=>setSelectedFaculty(e.target.value)} className="form-control form-control-lg">
                        <option disabled selected value> -- Spécifiez votre domaine -- </option>
                        {faculties.map(option=><option value={option.value} key={option.value}>{option.label}</option>)}
                    </select>
                </div>
            </div>
            <div className="row mt-2 mb-4">
                <div className="col-12">
                    <div className="col-12 mb-2"> le niveau actuel :</div>
                    <select value={selectedYear} onChange={(e)=>setSelectedYear(e.target.value)} className="form-control form-control-lg">
                        <option disabled selected value> -- Spécifiez votre année actuelle -- </option>
                        {years.map(option=><option value={option.value} key={option.value}>{option.label}</option>)}
                    </select>
                </div>
            </div>
            <div className="row mb-4">
                <div className="col-12 mb-2"> Spécifiez votre Niveau d'étude :</div>
                <div className="col-12">
                    <select value={selectedLevel} onChange={(e)=>setSelectedLevel(e.target.value)} className="form-control form-control-lg">
                        <option disabled selected value> -- Spécifiez votre niveau d'étude -- </option>
                        {levels.map(option=><option value={option.value} key={option.value}>{option.label}</option>)}
                    </select>
                </div>
            </div>
            { selectedLevel?.value==='Resident' ? (
                <div className="row mb-4">
                    <div className="col-12 mb-2"> Spécifiez votre Spécilaité :</div>
                    <div className="col-12">
                        <select value={selectedSpeciality} onChange={(e)=>setSelectedSpeciality(e.target.value)} className="form-control form-control-lg">
                            <option disabled selected value> -- Spécifiez votre spécilaité -- </option>
                            {specialities.map(option=><option value={option.value} key={option.value}>{option.label}</option>)}
                        </select>
                    </div>
                </div>
            ): null}



        </div>
    )
}
